export default function getExtensionFromFileName(fileName: string): string | null {
    if (!fileName) {
        return null;
    }

    const start: number = fileName.lastIndexOf('.');
    if (start > 0) {
        return fileName.substr(start).toLowerCase();
    }

    return null;
}

export function getExtensionWithoutDotFromFileName(fileName: string): string | null {
    const extension = getExtensionFromFileName(fileName);
    return extension ? extension.replace('.', '') : null;
}
